export var version = "3.11.4";
//# sourceMappingURL=version.js.map